"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _settingsDefault = require("./settings-default");

var _contexts = require("./contexts");

var _storage = _interopRequireDefault(require("./hooks/storage"));

var _siteActions = _interopRequireDefault(require("./hooks/site-actions"));

var _contentTracker = _interopRequireDefault(require("./hooks/content-tracker"));

var _timeTracker = _interopRequireDefault(require("./hooks/time-tracker"));

var _donationListener = _interopRequireDefault(require("./hooks/donation-listener"));

var _intrusiveness = _interopRequireDefault(require("./hooks/intrusiveness"));

var _targets = _interopRequireDefault(require("./hooks/targets"));

var _boxPositioner = _interopRequireDefault(require("./hooks/box-positioner"));

var _contentLock = _interopRequireDefault(require("./hooks/content-lock"));

var _box = _interopRequireDefault(require("../box"));

var _donationFeedback = _interopRequireDefault(require("../donation-feedback"));

var _pageFocus = _interopRequireDefault(require("./hooks/page-focus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function App(_ref) {
  let {
    currentContent,
    pageFocussed
  } = _ref;
  (0, _contentTracker.default)(currentContent);
  (0, _timeTracker.default)(pageFocussed);
  const [isFeedbackShown, hideFeedback] = (0, _donationListener.default)();
  const intrusivenessProps = (0, _intrusiveness.default)();
  const targets = (0, _targets.default)(currentContent);
  const boxes = (0, _boxPositioner.default)(intrusivenessProps, targets);
  const contentLockProps = (0, _contentLock.default)(intrusivenessProps, targets, boxes);
  const [contentLockActive] = contentLockProps;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, boxes.filter(boxProps => contentLockActive ? boxProps.isFirst : true).map(boxProps => /*#__PURE__*/_react.default.createElement(_reactPortal.Portal, {
    node: boxProps.wrapperEl,
    key: boxProps.key
  }, /*#__PURE__*/_react.default.createElement(_box.default, {
    boxProps,
    contentLockProps,
    isFeedbackShown
  }))), isFeedbackShown && /*#__PURE__*/_react.default.createElement(_donationFeedback.default, {
    hideFeedback: hideFeedback
  }));
}

function AppController() {
  const [settings, setSettings] = (0, _react.useState)(_settingsDefault.SETTINGS_DEFAULT_DISABLED);
  const pageFocussed = (0, _pageFocus.default)(settings.trackerEnabled);
  const storage = (0, _storage.default)(settings, pageFocussed);
  const currentContent = (0, _siteActions.default)(setSettings, storage);
  return /*#__PURE__*/_react.default.createElement(_contexts.Settings.Provider, {
    value: settings
  }, /*#__PURE__*/_react.default.createElement(_contexts.Storage.Provider, {
    value: storage
  }, /*#__PURE__*/_react.default.createElement(App, {
    currentContent: currentContent,
    pageFocussed: pageFocussed
  })));
}

var _default = AppController;
exports.default = _default;